import { __assign } from "tslib";
/* eslint-disable no-underscore-dangle */
import { monitor, callMonitored } from '../domain/internalMonitoring';
import { elapsed, relativeNow } from '../tools/timeUtils';
import { normalizeUrl } from '../tools/urlPolyfill';
var xhrProxySingleton;
var beforeSendCallbacks = [];
var onRequestCompleteCallbacks = [];
var originalXhrOpen;
var originalXhrSend;
var originalXhrAbort;
export function startXhrProxy() {
    if (!xhrProxySingleton) {
        proxyXhr();
        xhrProxySingleton = {
            beforeSend: function (callback) {
                beforeSendCallbacks.push(callback);
            },
            onRequestComplete: function (callback) {
                onRequestCompleteCallbacks.push(callback);
            },
        };
    }
    return xhrProxySingleton;
}
export function resetXhrProxy() {
    if (xhrProxySingleton) {
        xhrProxySingleton = undefined;
        beforeSendCallbacks.length = 0;
        onRequestCompleteCallbacks.length = 0;
        XMLHttpRequest.prototype.open = originalXhrOpen;
        XMLHttpRequest.prototype.send = originalXhrSend;
        XMLHttpRequest.prototype.abort = originalXhrAbort;
    }
}
function proxyXhr() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalXhrOpen = XMLHttpRequest.prototype.open;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalXhrSend = XMLHttpRequest.prototype.send;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalXhrAbort = XMLHttpRequest.prototype.abort;
    XMLHttpRequest.prototype.open = function (method, url) {
        var _this = this;
        callMonitored(function () {
            // WARN: since this data structure is tied to the instance, it is shared by both logs and rum
            // and can be used by different code versions depending on customer setup
            // so it should stay compatible with older versions
            _this._datadog_xhr = {
                method: method,
                startTime: -1,
                url: normalizeUrl(url),
            };
        });
        return originalXhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
        var _this = this;
        callMonitored(function () {
            if (_this._datadog_xhr) {
                var xhrPendingContext_1 = _this._datadog_xhr;
                xhrPendingContext_1.startTime = relativeNow();
                xhrPendingContext_1.isAborted = false;
                var originalOnreadystatechange_1 = _this.onreadystatechange;
                _this.onreadystatechange = function () {
                    if (this.readyState === XMLHttpRequest.DONE) {
                        // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                        // application during a future event. For example, Angular is calling .abort() on
                        // completed requests during a onreadystatechange event, so the status becomes '0'
                        // before the request is collected.
                        callMonitored(reportXhr_1);
                    }
                    if (originalOnreadystatechange_1) {
                        originalOnreadystatechange_1.apply(this, arguments);
                    }
                };
                var hasBeenReported_1 = false;
                var reportXhr_1 = function () {
                    if (hasBeenReported_1) {
                        return;
                    }
                    hasBeenReported_1 = true;
                    var xhrCompleteContext = __assign(__assign({}, xhrPendingContext_1), { duration: elapsed(xhrPendingContext_1.startTime, relativeNow()), response: _this.response, status: _this.status });
                    onRequestCompleteCallbacks.forEach(function (callback) { return callback(xhrCompleteContext); });
                };
                _this.addEventListener('loadend', monitor(reportXhr_1));
                beforeSendCallbacks.forEach(function (callback) { return callback(xhrPendingContext_1, _this); });
            }
        });
        return originalXhrSend.apply(this, arguments);
    };
    XMLHttpRequest.prototype.abort = function () {
        var _this = this;
        callMonitored(function () {
            if (_this._datadog_xhr) {
                _this._datadog_xhr.isAborted = true;
            }
        });
        return originalXhrAbort.apply(this, arguments);
    };
}
//# sourceMappingURL=xhrProxy.js.map